<template>
  <v-group :config="groupConfig">
    <template v-if="isComplete">

      <v-image
        ref="image"
        :config="Object.assign({}, imageConfig, {image: imageRaw})"
        v-if="showImage"
        @click="onClickGroup"
        @mouseover="onMouseOver"
        @mouseout="onMouseOut"
        @transformend="onUpdatePosition"
        @dragend="onUpdatePosition" />

      <v-icon
        :x="editIconPosition.x"
        :y="editIconPosition.y"
        v-if="isSelected"
        @click="editIconClick"
        iconName="editHeadlieIcon"
        iconType="edit" />

      <v-icon
        :x="collectIconPosition.x"
        :y="collectIconPosition.y"
        v-if="isSelected"
        @click="collectIconClick"
        iconName="collectHeadlieIcon"
        iconType="collect" />

    </template>
  </v-group>
</template>

<script>
import VIcon from './VIcon'
import CommitmentMixin from '@/components/Inline/CommitmentMixin'
import debounce from 'lodash.debounce';
import clonedeep from 'lodash.clonedeep'
const SAVE_GOAL_POSITION_THROTTLE_TIME = 1000;

export default {
  props: ['goal_id', 'goal_meta', 'stageSettings', 'isSelected'],
  mixins: [CommitmentMixin],
  data: () => ({
    imageRaw: null, // TODO: nicht in data
    aspectRatio: 1.0,
    imageScaleTest: 1.0,
  }),
  watch: {
    goal_meta( newValue ) {
      // take care of z-index
    }
  },
  created() {
    let publicGoal = this.goal_by_id( this.goal_id ); // <<< TODO
    if ( !this.imageRaw ) {
      const image = new window.Image();
      image.src = publicGoal.picture;
      console.log("* loading picutre", image.src);
      image.onload = (imageEvent) => {
        this.aspectRatio = image.width / image.height;
        this.imageRaw = image;
      }
    }
  },
  computed: {
    // ...mapGetters("goal", [
    //   'goal_by_id',
    //   // "goal_is_ready"
    // ]),

    isComplete() {
      return this.$api.get_ready( 'goal', this.goal_id )
    },

    showImage() {
      let userGoal = this.goal_meta;
      return userGoal.graphicalRepresentation.showImage;
    },

    groupConfig() {
      return {
        draggable:  false,
        x:          0,
        y:          0,
        rotation:   0,
        scaleX:     1,
        scaleY:     1,
      }
    },

    imageConfig() {
      let userGoal = this.goal_meta;
      // let publicGoal = this.goal_by_id( this.goal_id );

      let image = {
        name:          "goal-img-" + this.goal_id,
        width:         this.imageScaleTest * 200 * this.aspectRatio,
        height:        this.imageScaleTest * 200,
        x:             userGoal.graphicalRepresentation.x,
        y:             userGoal.graphicalRepresentation.y,
        rotation:      userGoal.graphicalRepresentation.rotation,
        scaleX:        userGoal.graphicalRepresentation.scaleX,
        scaleY:        userGoal.graphicalRepresentation.scaleY,
        shadowColor:   userGoal.graphicalRepresentation.shadowColor,
        shadowBlur:    userGoal.graphicalRepresentation.shadowBlur,
        shadowOffset:  userGoal.graphicalRepresentation.shadowOffset,
        shadowOpacity: userGoal.graphicalRepresentation.shadowOpacity,
        // src:           publicGoal ? publicGoal.picture : '',
        draggable:     true
      };
      return image;
    },

    editIconPosition() {
      let userGoal = this.goal_meta;
      return {
        x: userGoal.graphicalRepresentation.x - 30,
        y: userGoal.graphicalRepresentation.y - 20,
      }
    },

    collectIconPosition() {
      let userGoal = this.goal_meta;
      return {
        x: userGoal.graphicalRepresentation.x - 30,
        y: userGoal.graphicalRepresentation.y + 10,
      }
    },
  },
  methods: {

    onUpdatePosition: debounce(function (event) {
      console.log("dragGroup", event);

      let positionData = {
        x: parseInt( event.target.attrs.x ),
        y: parseInt( event.target.attrs.y ),
        scaleX: ( event.target.attrs.scaleX ),  // NEU
        scaleY: ( event.target.attrs.scaleY ),  // NEU
        rotation: parseInt( event.target.attrs.rotation ),  // NEU
      }

      // --> MIXIN
      const between = (min,v,max) => Math.max( min, Math.min(v, max) );
      positionData.scaleX = between(0.1, positionData.scaleX, 3.0);
      positionData.scaleY = between(0.1, positionData.scaleY, 3.0);
      positionData.x = between(0, positionData.x, this.stageSettings.width);
      positionData.y = between(0, positionData.y, this.stageSettings.height);

      if ( positionData.scaleX !== positionData.scaleY ) {
        console.log("I think aspect ratio should always stay the same, no?");
        positionData.scaleX = positionData.scaleY;
      }

      /* Workaround due to limitation that update_user_goal only supports
         nested data merge up to 1 level */
      let data = Object.assign({},
        this.goal_meta.graphicalRepresentation,
        {
          ...positionData,
          fontFamily: "Arial",
          fontSize: 24,
        }
      );
      data = clonedeep( data );
      console.log("graphicalRepresentation>>>", { graphicalRepresentation: data });
      this.$api.update_user_goal({ data: { graphicalRepresentation: data }, goal_id: this.goal_id });
      // ^ TODO

    }, SAVE_GOAL_POSITION_THROTTLE_TIME),

    collectIconClick() {
      // console.log("TODO");
      this.$emit('on-snap');
    },

    // --> MIXIN
    onClickGroup(event) {
      let node = this.$refs.image.getNode();
      this.$emit('click-group', { goalId: this.goal_id, node: node, event, type: 'image' });
    },

    // --> MIXIN
    onMouseOver(event) {
      document.body.style.cursor = 'pointer';
    },

    // --> MIXIN
    onMouseOut(event) {
      document.body.style.cursor = 'default';
    },

    // --> MIXIN
    editIconClick(event) {
      // console.log("editIconClick");
      this.$emit('select-image', { goalId: this.goal_id, event });
    },
  },
  components: {
    VIcon
  }
}
</script>
